import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export default {
  lista: function () {
    return Vue.http.get('/api/bancos').then(response => response.data);
  }
};



// WEBPACK FOOTER //
// ./FrontEnd/modulos/banco/servico.js